
import { ActionBase } from '../../../core/store/action/ActionBase';
import { ModuleConfiguration } from '../../datawarehouse.module.config';

export const CLONE_WORKSPACE = `[${ModuleConfiguration.moduleName}] Clone Workspace`;

export class CloneWorkspaceAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CLONE_WORKSPACE;

  constructor(public payload: { entityKey: string, scope?: string, key: string }) {}
}




// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/CloneWorkspaceAction.ts